/* Mail & calendar (OFFICE-05 email and calendar assistant; MEM-03 personal context from mail and
   calendar). Screen: Mail and Calendar tabs over api/src/modules/mail. */
import { lazy } from 'react';
import { Mail } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'mail',
  title: 'Mail & calendar',
  short: 'Mail',
  icon: Mail,
  group: 'Apps',
  route: '/mail',
  order: 10,
  rail: true,
  screen: lazy(() => import('./Screen.tsx')),
  capabilities: ['OFFICE-05', 'MEM-03', 'OFFICE-13', 'OFFICE-14', 'OFFICE-15', 'OFFICE-16'],
  commands: [
    { id: 'compose', title: 'Compose email', to: '/mail/compose', shortcut: 'C', keywords: ['mail', 'write', 'new message'] },
    { id: 'digest', title: 'Catch me up on email', to: '/mail?digest=1', keywords: ['digest', 'summary', 'inbox', 'brief'] },
    { id: 'search', title: 'Search mail', to: '/mail?search=1', shortcut: '/', keywords: ['find', 'email'] },
    { id: 'triage', title: 'Re-sort the inbox with AI', to: '/mail?triage=1', keywords: ['triage', 'needs you', 'sort'] },
    { id: 'calendar', title: 'Open calendar', to: '/mail/calendar', keywords: ['week', 'events', 'schedule'] },
    { id: 'new-event', title: 'New calendar event', to: '/mail/calendar?new=1', keywords: ['meeting', 'invite'] },
    { id: 'find-slot', title: 'Find a meeting slot', to: '/mail/calendar?find=1', keywords: ['free', 'busy', 'schedule', 'availability'] },
    { id: 'rules', title: 'Mail rules', to: '/mail?settings=rules', keywords: ['filters', 'automation'] },
    { id: 'cleanup', title: 'Clean up newsletters', to: '/mail?settings=cleanup', keywords: ['unsubscribe', 'bulk'] },
    { id: 'accounts', title: 'Link a mail account', to: '/mail?settings=accounts', keywords: ['gmail', 'google', 'connect', 'unlink'] },
    { id: 'context', title: 'Personal context from mail and calendar', to: '/mail?settings=prefs', keywords: ['memory', 'privacy', 'MEM-03'] },
  ],
});
